import { Box, Button, Paper, Typography } from "@mui/material";

interface ProposalBannerProps {
  onAction?: () => void;
}

export default function ProposalBanner({ onAction }: ProposalBannerProps) {
  return (
    <Paper
      sx={{
        bgcolor: "#fff8f2",
        borderRadius: "12px",
        p: 2,
        mb: 2,
        display: "flex",
        alignItems: "center",
        gap: 2,
        boxShadow: 0,
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Typography
          sx={{ fontWeight: 700, fontSize: "18px", color: "#c59a70", mb: 0.5 }}
        >
          Follow up on the last proposal you sent to client
        </Typography>
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "12px",
            color: "#c59a70",
            lineHeight: 1.5,
          }}
        >
          To gather client feedback, it is important to create a thoughtful
          review request. Reach out after completing a project or service, thank
          them for their business, and invite them to share their experiences.
        </Typography>
      </Box>
      <Button
        onClick={onAction}
        sx={{
          bgcolor: "#c59a70",
          color: "white",
          borderRadius: "8px",
          px: 3,
          py: 1.5,
          textTransform: "none",
          fontWeight: 500,
          fontSize: "12px",
          minWidth: 97,
          height: 45,
          "&:hover": { bgcolor: "#b08960" },
        }}
      >
        Action
      </Button>
    </Paper>
  );
}
